<div class="page">

<div class="saving" *ngIf="isSaving">
  <i class="fa-solid fa-circle-notch fa-spin"></i> 
  <span>Saving...</span>
</div>
  <div class="page-navigation">
    <div class="page-hint">Page {{pageModel.order+1}} of {{totalPageCount}}</div>
  </div>
  <!-- <div class="page-header">
    <h1 class="m-t-0">{{pageModel.title}}</h1>
  </div> -->
  <app-elite-form-response-page-single-section [eliteFormId]="pageModel.eliteFormId" [platformDialog]="platformDialog"
    [itemId]="itemId" [inputForm]="inputForm"
    (fieldValueChanges)="onFieldValueChange($event)"
    (sectionIncluded)="onSectionIncluded()"></app-elite-form-response-page-single-section>
</div>
